var ApiRequestLogEntry = Backbone.Model.extend({

});

var ApiRequestLog = Backbone.Collection.extend({
    model: ApiRequestLogEntry,
    url: function() {
        return Core.contextRoot + '/apiconsumer/' + this.key + '/requestlog'
    },
    initialize: function(models, options) {
        this.key = options.key;
    },
});
